import { Link } from "react-router-dom";

export function RulesSearchResults({ results, query, suffix, onPick }) {
  return (
    <div data-testid="rules-search-results" aria-live="polite">
      <p className="mb-6 text-sm text-eden-muted">{results.length} resultado{results.length === 1 ? "" : "s"} para “{query}”</p>
      {results.length === 0 && <p className="card-eden p-8 text-center text-eden-secondary">Nenhuma regra corresponde à pesquisa.</p>}
      <ol className="space-y-3">
        {results.map((r) => (
          <li key={r.id} className="card-eden p-5">
            <Link to={`/regras/${r.category.slug}${suffix}#${r.anchor}`} onClick={onPick} className="group block" data-testid={`rules-result-${r.anchor}`}>
              <p className="font-mono text-xs text-eden-orange">{r.number} · {r.category.title}{r.group ? ` · ${r.group}` : ""}</p>
              {r.title && <h3 className="mt-1 font-display text-lg font-semibold text-eden-text group-hover:underline">{r.title}</h3>}
              <p className={`mt-1 line-clamp-3 text-sm ${r.title ? "text-eden-secondary" : "text-eden-text group-hover:underline"}`}>{r.body}</p>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}
